"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoTab = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const molecules_1 = require("../../molecules");
const molecules_2 = require("../../molecules");
const device_1 = require("@completeanatomy/device");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
function InfoTab({ className }) {
    const { isMobile } = (0, device_1.usePlatform)();
    const tabContent = (0, hooks_1.useTabContent)(bridge_schema_1.InfoBoxTabType.Description);
    const { extra, items } = tabContent;
    return ((0, jsx_runtime_1.jsxs)(Container, { className: className, "data-e2e": 'InfoTab_Container', children: [extra && (0, jsx_runtime_1.jsx)(StyledDescription, { "data-e2e": 'InfoTab_StyledDescription', children: extra }), !isMobile && items && (0, jsx_runtime_1.jsx)(molecules_2.PlanesThumbnails, { "data-e2e": 'InfoTab_PlanesThumbnails', children: items })] }));
}
exports.InfoTab = InfoTab;
const Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;

  height: 100%;

  overflow: hidden;
`;
const StyledDescription = (0, styled_components_1.default)(molecules_1.Description) `
  padding: 0 8px env(safe-area-inset-bottom) 0;
  padding: 0 8px constant(safe-area-inset-bottom) 0;

  font-size: 16px;

  ${ui_1.device.tablet((0, styled_components_1.css) `
    flex-shrink: unset;

    padding: 6px 8px 6px 0;

    font-size: 13px;
  `)}
`;
